import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./complaint.scss"
import { Form, Formik } from 'formik';
import { visitUpdate } from '../../../service/api/visit';
import CustomModal from '../../common/modal/modal';
import { put, post, get, del } from "../../../utils/fetchAPI";
import { showSuccessToast } from '../../../utils/toaster-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPenToSquare, faSquareCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import CreatableSearchSelect from '../../common/updated-input/createble-search-select/creatable-search-select';
import { ToolTip } from '../../common/tooltip/tooltip';

const Complaint = ({ visitDetails = {}, updateState }) => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [info, setInfo] = useState({});
    const [showAdd, setShowAdd] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [templateInfo, setTemplateInfo] = useState({})
    const [templateList, setTemplateList] = useState([])
    const [presentIllnessList, setPresentIllnessList] = useState([])
    const [complaintsNote, setComplaintNote] = useState([])
    const timeoutIdRef = useRef(null)
    const [showTemplates, setShowTemplates] = useState(false)
    const [showNotes, setShowNotes] = useState(false)
    const [showPresentIllness, setShowPresentIllness] = useState(false)
    const [showPresenetDelete, setShowPresenetDelete] = useState(false)
    const [showComplaintNote, setShowComplaintNote] = useState(false)
    const [showComplaintNoteDelte, setShowComplaintNoteDelete] = useState(false)
    const [tplSearch, setTplSearch] = useState({ complaint: "", presentIllness: "" })

    useEffect(() => {
        if (visitDetails?.doctor) {
            getTemplateList(visitDetails?.doctor)
            getPresentIllnessList(visitDetails?.doctor)
            getNoteList(visitDetails?.doctor)
        }
    }, [visitDetails?.doctor])

    // The lists below are shared with the CreatableSearchSelect typeaheads, which refetch
    // them narrowed by whatever the doctor typed. Reload them unfiltered so the manager
    // always opens on the full set.
    const openTemplateManager = () => {
        setTplSearch({ complaint: "", presentIllness: "" })
        if (visitDetails?.doctor) {
            getTemplateList(visitDetails?.doctor)
            getPresentIllnessList(visitDetails?.doctor)
        }
        setShowTemplates(true)
    }

    // Reason For Visit
    const setReasonForVisitOptionFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { (getTemplateList(visitDetails?.doctor, event?.target?.value)) }, 500)
    }
    const handleReasonForVisitAddSubmit = (value) => {
        let data = { ...info }
        let updatedReasonForVisit = ((data?.reasonForVisit || "") + (data?.reasonForVisit ? "\n" : "") + (value?.reasonForVisit || ""))
        updateComplaint({ reasonForVisitId: value?._id, reasonForVisit: updatedReasonForVisit, historyOfPresetIllness: data?.historyOfPresetIllness, extraNote: data?.extraNote })
        showSuccessToast("Added")
    }
    const handleCreatePastIlless = (value) => {
        let data = { ...info }
        let updatedReasonForVisit = ((data?.reasonForVisit || "") + (data?.reasonForVisit ? "\n" : "") + (value || ""))
        updateComplaint({ reasonForVisit: updatedReasonForVisit, historyOfPresetIllness: data?.historyOfPresetIllness, extraNote: data?.extraNote })
        createNewComplaintTemplate(value)
    }

    // Present Illness
    const setPresentIllnessOptionFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { (getPresentIllnessList(visitDetails?.doctor, event?.target?.value)) }, 500)
    }
    const handlePresentIllnessAddSubmit = (value) => {
        let data = { ...info }
        let updatedPresentIlness = ((data?.historyOfPresetIllness || "") + (data?.historyOfPresetIllness ? "\n" : "") + (value?.historyOfPresetIllness || ""))
        updateComplaint({ historyOfPresentIllnessId: value?._id, reasonForVisit: data?.reasonForVisit, historyOfPresetIllness: updatedPresentIlness, extraNote: data?.extraNote })
        showSuccessToast("Added")
    }
    const handleCreatePresentIllness = (value) => {
        let data = { ...info }
        let updatedPresentIlness = ((data?.historyOfPresetIllness || "") + (data?.historyOfPresetIllness ? "\n" : "") + (value || ""))
        updateComplaint({ reasonForVisit: data?.reasonForVisit, historyOfPresetIllness: updatedPresentIlness, extraNote: data?.extraNote })
        createNewpresenetIllnessTemplate(value)
    }

    // Note
    const setComplaintNoteFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { (getNoteList(visitDetails?.doctor, event?.target?.value)) }, 500)
    }
    const handleComplaintNoteAddSubmit = (value) => {
        let data = { ...info }
        let updatedNote = ((data?.extraNote || "") + (data?.extraNote ? "\n" : "") + (value?.chiefCompliantNote || ""))
        updateComplaint({ reasonForVisit: data?.reasonForVisit, historyOfPresetIllness: data?.historyOfPresetIllness, extraNote: updatedNote })
        showSuccessToast("Added")
    }
    const handleCreateComplaintNote = (value) => {
        let data = { ...info }
        let updatedNote = ((data?.extraNote || "") + (data?.extraNote ? "\n" : "") + (value || ""))
        updateComplaint({ reasonForVisit: data?.reasonForVisit, historyOfPresetIllness: data?.historyOfPresetIllness, extraNote: updatedNote })
        createComplaintNoteTemplate(value)
    }

    const setInfoFun = (key, value, submit = false) => {
        let temp = { ...info, [key]: value };
        setInfo(temp);
        if (submit) { onSubmit(temp) }
    };

    const onSubmit = async (values) => { updateComplaint(values) };

    const setReasonForvisit = async (value) => {
        let values = { reasonForVisit: info?.reasonForVisit + (info?.reasonForVisit ? "\n" : "") + value, historyOfPresetIllness: info?.historyOfPresetIllness, extraNote: info?.extraNote }
        setInfo(values)
        await updateComplaint(values)
    }
    const setHistoryOfPresentIllness = async (value) => {
        let values = { reasonForVisit: info?.reasonForVisit, historyOfPresetIllness: info?.historyOfPresetIllness + (info?.historyOfPresetIllness ? "\n" : "") + value, extraNote: info?.extraNote }
        setInfo(values)
        await updateComplaint(values)
    }

    function updateComplaint(values) {
        setIsSubmitting(true)
        visitUpdate(values, visitDetails?._id)
            .then((res) => {
                if (res?.status == 200) { setIsSubmitting(false); updateState(res.data) }
            })
            .catch(() => { setIsSubmitting(false) });
    }

    const handleKeyDown = (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 's') {
            event.preventDefault();
            updateComplaint({ reasonForVisit: info?.reasonForVisit, historyOfPresetIllness: info?.historyOfPresetIllness, extraNote: info?.extraNote })
        }
    }
    useEffect(() => {
        if (info) document.addEventListener('keydown', handleKeyDown);
        return () => { document.removeEventListener('keydown', handleKeyDown) };
    }, [info]);

    const createNewComplaintTemplate = async (value = info?.reasonForVisit) => {
        await post(`/doctor/complaints`, { reasonForVisit: value })
            .then((res) => { if (res?.status == 200) { getTemplateList(visitDetails?.doctor); showSuccessToast("Saved as template") } })
            .catch(() => {});
    }
    const createNewpresenetIllnessTemplate = async (value = info?.historyOfPresetIllness) => {
        await post(`/doctor/presentIllness`, { historyOfPresetIllness: value })
            .then((res) => { if (res?.status == 200) { getPresentIllnessList(visitDetails?.doctor); showSuccessToast("Saved as template") } })
            .catch(() => {});
    }
    const createComplaintNoteTemplate = async (value = info?.extraNote) => {
        await post(`/doctor/complaint/notes`, { chiefCompliantNote: value })
            .then((res) => { if (res?.status == 200) { getNoteList(visitDetails?.doctor); showSuccessToast("Saved as template") } })
            .catch(() => {});
    }

    const getTemplateList = async (doctorId, search = "") => {
        await get(`/doctor/complaints/list/${doctorId}${search ? (`?search=${search}`) : ""}`)
            .then((res) => { if (res?.status == 200) setTemplateList(res?.data) })
            .catch(() => {});
    }
    const getPresentIllnessList = async (doctorId, search = "") => {
        await get(`/doctor/presentIllness/list/${doctorId}${search ? (`?search=${search}`) : ""}`)
            .then((res) => { if (res?.status == 200) setPresentIllnessList(res?.data) })
            .catch(() => {});
    }
    const getNoteList = async (doctorId, search = "") => {
        await get(`/doctor/complaintsNote/list/${doctorId}${search ? (`?search=${search}`) : ""}`)
            .then((res) => { if (res?.status == 200) setComplaintNote(res?.data) })
            .catch(() => {});
    }

    const updateTemplate = async (type) => {
        let { historyOfPresetIllness, ...payload } = templateInfo
        await put(`/doctor/${type}/update`, payload)
            .then((res) => { if (res?.status == 200) { getTemplateList(visitDetails?.doctor); setTemplateInfo({}); setShowAdd(false); showSuccessToast("Updated successfully") } })
            .catch(() => {});
    }
    const updatePresnetIllness = async () => {
        let { reasonForVisit, ...payload } = templateInfo
        await put(`/doctor/presentIllness/update`, payload)
            .then((res) => { if (res?.status == 200) { getPresentIllnessList(visitDetails?.doctor); setTemplateInfo({}); setShowPresentIllness(false); showSuccessToast("Updated successfully") } })
            .catch(() => {});
    }
    const updateComplaintNote = async () => {
        let { reasonForVisit, historyOfPresetIllness, ...payload } = templateInfo
        await put(`/doctor/complaintsNote/update`, payload)
            .then((res) => { if (res?.status == 200) { getNoteList(visitDetails?.doctor); setTemplateInfo({}); setShowComplaintNote(false); showSuccessToast("Updated successfully") } })
            .catch(() => {});
    }

    const deleteTemplate = async (type, id) => {
        await del(`/doctor/${type}/delete/${id}`)
            .then((res) => { if (res?.status == 200) { getTemplateList(visitDetails?.doctor); setTemplateInfo({}); setShowDelete(false); showSuccessToast("Deleted successfully") } })
            .catch(() => {});
    }
    const deletePresentIllness = async (id) => {
        await del(`/doctor/presentIllness/delete/${id}`)
            .then((res) => { if (res?.status == 200) { getPresentIllnessList(visitDetails?.doctor); setTemplateInfo({}); setShowPresenetDelete(false); showSuccessToast("Deleted successfully") } })
            .catch(() => {});
    }
    const deleteComplaintNote = async (id) => {
        await del(`/doctor/complaintsNote/delete/${id}`)
            .then((res) => { if (res?.status == 200) { getNoteList(visitDetails?.doctor); setTemplateInfo({}); setShowComplaintNoteDelete(false); showSuccessToast("Deleted successfully") } })
            .catch(() => {});
    }

    const filteredTemplateList = useMemo(() => {
        const q = tplSearch.complaint.trim().toLowerCase()
        if (!q) return templateList || []
        return (templateList || []).filter((t) => (t?.reasonForVisit || "").toLowerCase().includes(q))
    }, [templateList, tplSearch.complaint])

    const filteredPresentIllnessList = useMemo(() => {
        const q = tplSearch.presentIllness.trim().toLowerCase()
        if (!q) return presentIllnessList || []
        return (presentIllnessList || []).filter((t) => (t?.historyOfPresetIllness || "").toLowerCase().includes(q))
    }, [presentIllnessList, tplSearch.presentIllness])

    useMemo(() => {
        if (visitDetails) {
            setInfo({ reasonForVisit: visitDetails?.reasonForVisit || "", historyOfPresetIllness: visitDetails?.historyOfPresetIllness || "", extraNote: visitDetails?.extraNote || "", currentMedication: visitDetails?.currentMedication });
        }
    }, [visitDetails])

    return (
        <div className="cc-wrap">

            {isSubmitting && (
                <div className="cc-saving-badge" aria-live="polite">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Saving…
                </div>
            )}

            {visitDetails && (
                <Formik initialValues={{}} onSubmit={onSubmit}>
                    {() => (
                        <Form className="cc-grid" encType="multipart/form-data" noValidate>

                            {/* ── Reason For Visit ───────────────────────── */}
                            <div className="cc-field">
                                <CreatableSearchSelect
                                    options={templateList}
                                    setOptionFun={setReasonForVisitOptionFun}
                                    handleSubmit={handleReasonForVisitAddSubmit}
                                    handleCreate={handleCreatePastIlless}
                                />
                                <div className="cc-field__header">
                                    <span className="cc-field__label">Reason For Visit</span>
                                    <div className="cc-field__actions">
                                        <button type="button" className="cc-field__tpl-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => createNewComplaintTemplate()}>
                                            Save as template
                                        </button>
                                        <button type="button" className="cc-field__gear-btn" title="Manage templates" onClick={openTemplateManager}>
                                            <FontAwesomeIcon icon={faGear} />
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    className="cc-field__textarea"
                                    rows={5}
                                    placeholder="Reason For Visit"
                                    value={info?.reasonForVisit || ""}
                                    onChange={(e) => setInfoFun("reasonForVisit", e.target.value)}
                                    onBlur={(e) => setInfoFun("reasonForVisit", e.target.value, true)}
                                />
                            </div>

                            {/* ── History Of Present Illness ─────────────── */}
                            <div className="cc-field">
                                <CreatableSearchSelect
                                    options={presentIllnessList}
                                    setOptionFun={setPresentIllnessOptionFun}
                                    handleSubmit={handlePresentIllnessAddSubmit}
                                    handleCreate={handleCreatePresentIllness}
                                />
                                <div className="cc-field__header">
                                    <span className="cc-field__label">History Of Present Illness</span>
                                    <div className="cc-field__actions">
                                        <button type="button" className="cc-field__tpl-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => createNewpresenetIllnessTemplate()}>
                                            Save as template
                                        </button>
                                        <button type="button" className="cc-field__gear-btn" title="Manage templates" onClick={openTemplateManager}>
                                            <FontAwesomeIcon icon={faGear} />
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    className="cc-field__textarea"
                                    rows={5}
                                    placeholder="History Of Present Illness"
                                    value={info?.historyOfPresetIllness || ""}
                                    onChange={(e) => setInfoFun("historyOfPresetIllness", e.target.value)}
                                    onBlur={(e) => setInfoFun("historyOfPresetIllness", e.target.value, true)}
                                />
                            </div>

                            {/* ── Note ───────────────────────────────────── */}
                            <div className="cc-field">
                                <CreatableSearchSelect
                                    options={complaintsNote || []}
                                    setOptionFun={setComplaintNoteFun}
                                    handleSubmit={handleComplaintNoteAddSubmit}
                                    handleCreate={handleCreateComplaintNote}
                                />
                                <div className="cc-field__header">
                                    <span className="cc-field__label">Note</span>
                                    <div className="cc-field__actions">
                                        <button type="button" className="cc-field__tpl-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => createComplaintNoteTemplate()}>
                                            Save as template
                                        </button>
                                        <button type="button" className="cc-field__gear-btn" title="Manage note templates" onClick={() => setShowNotes(true)}>
                                            <FontAwesomeIcon icon={faGear} />
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    className="cc-field__textarea"
                                    rows={4}
                                    placeholder="Note"
                                    value={info?.extraNote || ""}
                                    onChange={(e) => setInfoFun("extraNote", e.target.value)}
                                    onBlur={(e) => setInfoFun("extraNote", e.target.value, true)}
                                />
                            </div>

                        </Form>
                    )}
                </Formik>
            )}

            {/* ── Edit: Reason For Visit template ───────────────────────────── */}
            <CustomModal size="md" show={showAdd} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Edit Template — Reason For Visit</p>
                    <textarea
                        className="cc-modal__textarea"
                        rows={4}
                        value={templateInfo?.reasonForVisit || ""}
                        onChange={(e) => setTemplateInfo({ reasonForVisit: e.target.value, historyOfPresetIllness: templateInfo?.historyOfPresetIllness || "", chiefCompliantId: templateInfo?.chiefCompliantId, doctorId: visitDetails?.doctor })}
                        placeholder="Enter template content"
                    />
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--primary" onClick={() => updateTemplate("complaints")}>Update</button>
                        <button className="cc-modal__btn" onClick={() => setShowAdd(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Delete: Reason For Visit template ─────────────────────────── */}
            <CustomModal size="sm" show={showDelete} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Delete Template</p>
                    <p className="cc-modal__text">Are you sure you want to delete this template?</p>
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--danger" onClick={() => deleteTemplate("complaints", templateInfo?.chiefCompliantId)}>Delete</button>
                        <button className="cc-modal__btn" onClick={() => setShowDelete(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Edit: Present Illness template ────────────────────────────── */}
            <CustomModal size="md" show={showPresentIllness} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Edit Template — History of Present Illness</p>
                    <textarea
                        className="cc-modal__textarea"
                        rows={4}
                        value={templateInfo?.historyOfPresetIllness || ""}
                        onChange={(e) => setTemplateInfo({ historyOfPresetIllness: e.target.value, historyOfPresetIllnessId: templateInfo?.historyOfPresetIllnessId, doctorId: visitDetails?.doctor })}
                        placeholder="Enter template content"
                    />
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--primary" onClick={updatePresnetIllness}>Update</button>
                        <button className="cc-modal__btn" onClick={() => setShowPresentIllness(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Delete: Present Illness template ──────────────────────────── */}
            <CustomModal size="sm" show={showPresenetDelete} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Delete Template</p>
                    <p className="cc-modal__text">Are you sure you want to delete this template?</p>
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--danger" onClick={() => deletePresentIllness(templateInfo?.presentIllnessId)}>Delete</button>
                        <button className="cc-modal__btn" onClick={() => setShowPresenetDelete(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Edit: Note template ───────────────────────────────────────── */}
            <CustomModal size="md" show={showComplaintNote} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Edit Template — Note</p>
                    <textarea
                        className="cc-modal__textarea"
                        rows={4}
                        value={templateInfo?.chiefCompliantNote || ""}
                        onChange={(e) => setTemplateInfo({ chiefCompliantNote: e.target.value, chiefCompliantNoteId: templateInfo?.chiefCompliantNoteId, doctorId: visitDetails?.doctor })}
                        placeholder="Enter template content"
                    />
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--primary" onClick={updateComplaintNote}>Update</button>
                        <button className="cc-modal__btn" onClick={() => setShowComplaintNote(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Delete: Note template ─────────────────────────────────────── */}
            <CustomModal size="sm" show={showComplaintNoteDelte} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Delete Template</p>
                    <p className="cc-modal__text">Are you sure you want to delete this template?</p>
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--danger" onClick={() => deleteComplaintNote(templateInfo?.chiefCompliantNoteId)}>Delete</button>
                        <button className="cc-modal__btn" onClick={() => setShowComplaintNoteDelete(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Template Manager: Chief Complaint + HOPI ──────────────────── */}
            <CustomModal size="xl" show={showTemplates} isHeaderHide={true}>
                <div className="cc-tpl-modal">
                    <div className="cc-tpl-modal__head">
                        <h2 className="cc-tpl-modal__title">Template Manager</h2>
                        <button className="cc-tpl-modal__close" onClick={() => setShowTemplates(false)}>Close</button>
                    </div>
                    <div className="cc-tpl-modal__body">
                        <div className="cc-tpl-col">
                            <div className="cc-tpl-col__head">
                                <h3 className="cc-tpl-col__title">Chief Complaint</h3>
                                <input
                                    type="text"
                                    className="cc-tpl-col__search"
                                    placeholder="Search chief complaint templates"
                                    value={tplSearch.complaint}
                                    onChange={(e) => setTplSearch((s) => ({ ...s, complaint: e.target.value }))}
                                />
                            </div>
                            {filteredTemplateList?.length > 0 ? filteredTemplateList.map((complaint, index) => (
                                <div key={index} className="cc-tpl-row">
                                    <textarea className="cc-tpl-row__text" rows={2} disabled readOnly value={complaint?.reasonForVisit || ""} />
                                    <div className="cc-tpl-row__actions">
                                        <ToolTip text="Use">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--use" onClick={() => handleReasonForVisitAddSubmit(complaint)}>
                                                <FontAwesomeIcon icon={faSquareCheck} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Edit">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--edit" onClick={() => { setTemplateInfo({ reasonForVisit: complaint?.reasonForVisit || "", chiefCompliantId: complaint?._id, doctorId: visitDetails?.doctor }); setShowAdd(true); }}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Delete">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--del" onClick={() => { setTemplateInfo({ chiefCompliantId: complaint?._id }); setShowDelete(true); }}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </ToolTip>
                                    </div>
                                </div>
                            )) : <p className="cc-tpl-col__empty">{tplSearch.complaint.trim() ? "No templates match your search." : "No templates yet."}</p>}
                        </div>

                        <div className="cc-tpl-col">
                            <div className="cc-tpl-col__head">
                                <h3 className="cc-tpl-col__title">History Of Present Illness</h3>
                                <input
                                    type="text"
                                    className="cc-tpl-col__search"
                                    placeholder="Search history of present illness templates"
                                    value={tplSearch.presentIllness}
                                    onChange={(e) => setTplSearch((s) => ({ ...s, presentIllness: e.target.value }))}
                                />
                            </div>
                            {filteredPresentIllnessList?.length > 0 ? filteredPresentIllnessList.map((complaint, index) => (
                                <div key={index} className="cc-tpl-row">
                                    <textarea className="cc-tpl-row__text" rows={2} disabled readOnly value={complaint?.historyOfPresetIllness || ""} />
                                    <div className="cc-tpl-row__actions">
                                        <ToolTip text="Use">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--use" onClick={() => handlePresentIllnessAddSubmit(complaint)}>
                                                <FontAwesomeIcon icon={faSquareCheck} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Edit">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--edit" onClick={() => { setTemplateInfo({ historyOfPresetIllness: complaint?.historyOfPresetIllness || "", historyOfPresetIllnessId: complaint?._id, doctorId: visitDetails?.doctor }); setShowPresentIllness(true); }}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Delete">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--del" onClick={() => { setTemplateInfo({ presentIllnessId: complaint?._id }); setShowPresenetDelete(true); }}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </ToolTip>
                                    </div>
                                </div>
                            )) : <p className="cc-tpl-col__empty">{tplSearch.presentIllness.trim() ? "No templates match your search." : "No templates yet."}</p>}
                        </div>
                    </div>
                </div>
            </CustomModal>

            {/* ── Template Manager: Notes ────────────────────────────────────── */}
            <CustomModal size="md" show={showNotes} isHeaderHide={true}>
                <div className="cc-tpl-modal">
                    <div className="cc-tpl-modal__head">
                        <h2 className="cc-tpl-modal__title">Notes Templates</h2>
                        <button className="cc-tpl-modal__close" onClick={() => setShowNotes(false)}>Close</button>
                    </div>
                    <div className="cc-tpl-modal__body cc-tpl-modal__body--single">
                        <div className="cc-tpl-col">
                            {complaintsNote?.length > 0 ? complaintsNote.map((complaint, index) => (
                                <div key={index} className="cc-tpl-row">
                                    <textarea className="cc-tpl-row__text" rows={2} disabled readOnly value={complaint?.chiefCompliantNote || ""} />
                                    <div className="cc-tpl-row__actions">
                                        <ToolTip text="Use">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--use" onClick={() => handleComplaintNoteAddSubmit(complaint)}>
                                                <FontAwesomeIcon icon={faSquareCheck} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Edit">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--edit" onClick={() => { setTemplateInfo({ chiefCompliantNote: complaint?.chiefCompliantNote || "", chiefCompliantNoteId: complaint?._id, doctorId: visitDetails?.doctor }); setShowComplaintNote(true); }}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Delete">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--del" onClick={() => { setTemplateInfo({ chiefCompliantNoteId: complaint?._id }); setShowComplaintNoteDelete(true); }}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </ToolTip>
                                    </div>
                                </div>
                            )) : <p className="cc-tpl-col__empty">No notes templates yet.</p>}
                        </div>
                    </div>
                </div>
            </CustomModal>

        </div>
    )
}

export default Complaint
